import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import {
  EMAIL_INPUT_ALLOWED_CHARACTERS_REGEX,
  InputComponentWrapper,
} from '../../constants';
import { ValidationService } from '../validation.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'conn-email-input',
  templateUrl: './email-input.component.html',
  styleUrls: ['./email-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmailInputComponent implements OnInit {
  private validation = inject(ValidationService);

  @Input() submitted: boolean;
  @Input() inputModel = '';
  @Input() required: boolean;
  @Input() labelName: string;
  @Output() modelChanged: EventEmitter<InputComponentWrapper>;
  @Output() customBlur: EventEmitter<Event>;
  isValid: boolean;
  environment = environment;

  constructor() {
    this.modelChanged = new EventEmitter<InputComponentWrapper>();
    this.customBlur = new EventEmitter<Event>();
  }

  ngOnInit() {
    this.isValid = this.validation.isEmailValid(this.inputModel, this.required);
  }

  changeModel(changedData: string) {
    if (changedData !== undefined && changedData !== this.inputModel) {
      this.inputModel = changedData;
      this.submitted = false;
      this.isValid = this.validation.isEmailValid(
        this.inputModel,
        this.required,
      );
      this.modelChanged.emit({
        inputText: changedData,
        isValid: this.isValid,
      } as InputComponentWrapper);
    }
  }

  /**
   * this informs the parent that the component has just experienced a blur event while also setting this component
   * to a submitted state meaning that any validation cases will be in effect
   */
  emitBlur() {
    this.submitted = true;
    this.customBlur.emit(new Event('blur'));
  }

  /**
   * Restricts input to valid email characters: alphanumeric, period, hyphen, underscore, plus, and @
   * This provides better UX by preventing invalid characters from being typed
   */
  onKeyPress(event: KeyboardEvent): boolean {
    const char = event.key;

    // Allow control keys (backspace, delete, arrow keys, etc.)
    if (
      event.ctrlKey ||
      event.metaKey ||
      char.length > 1 // Control keys like 'Backspace', 'Delete', 'ArrowLeft', etc.
    ) {
      return true;
    }

    // Check if the character matches the allowed pattern
    if (!EMAIL_INPUT_ALLOWED_CHARACTERS_REGEX.test(char)) {
      event.preventDefault();
      return false;
    }

    return true;
  }
}
